/**
  * @desc Create fake lazyload on content, and real lazyload on the image. Also includes the .visible() function
  example selector.visible(true)
  * @author Danni Larsen - DLA, JHA - Jonas Havmøller
  * @return bool - true or false
  * @requires jquery@1.11.3,  .come-in less class
*/

var novicell = novicell || {};

// Extend jQuery with visible
$.fn.visible = function(partial) {

  var $t            = $(this),
      $w            = $(window),
      viewTop       = $w.scrollTop(),
      viewBottom    = viewTop + $w.height(),
      _top          = $t.offset().top,
      _bottom       = _top + $t.height(),
      compareTop    = partial === true ? _bottom : _top,
      compareBottom = partial === true ? _top : _bottom;

return ((compareBottom <= viewBottom) && (compareTop >= viewTop));

};

novicell.lazyload = new function(){

	this.box = function (selector) {
	    $(selector).each(function () {
	    	var $this = $(this),
	    		$img = $this.find('img');


	        if (!$this.hasClass('come-in') && $this.visible(true)) {
	            // Lazyload image
	            var path = $img.attr('data-src');
	            if (path != undefined) {
	            	$img.attr('src', path);
	            	$img.css('opacity', 1);
	            }

	            // Animate the element
	            $this.addClass('come-in');
	        }
	    });
	};

};
